(function () {
  'use strict';

  var FORMATTER = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  function fmt(cents) { return FORMATTER.format(cents / 100); }

  var apiBase = window.__wghApiBase || '';
  var activeDiscounts = {}; // sessionId → price_rule_id, survives between run() calls

  function deleteCartDiscount(priceRuleId) {
    if (!apiBase || !priceRuleId) return;
    fetch(apiBase + '/api/shopify/deleteDiscount', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ price_rule_id: parseInt(priceRuleId) })
    })
    .then(function () { window.location.reload(); })
    .catch(function (err) { console.warn('[WGH cart] discount delete fout:', err); });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function fixCartBubble(cart) {
    var realCount = (cart.items || []).reduce(function (sum, item) {
      if ((item.properties || {})._wgh_addon === '1') return sum;
      return sum + item.quantity;
    }, 0);
    var realStr = String(realCount);
    // Header cart-icon bubble (Dawn)
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      var numEl = bubble.querySelector('[aria-hidden="true"]');
      if (numEl) numEl.textContent = realStr;
    });
    // Mega-menu badge
    document.querySelectorAll('.site-hdr__cart-badge').forEach(function (badge) {
      badge.textContent = realStr;
      badge.setAttribute('aria-label', realStr + ' items');
    });
  }

  function removeCartItems(keys) {
    if (!keys.length) return Promise.resolve();
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  function showAll() {
    document.querySelectorAll('[id^="CartItem-"]').forEach(function (el) {
      el.classList.add('wgh-ready');
    });
  }

  function run() {
    fetchCart().then(function (cart) {
      fixCartBubble(cart);
      var items = cart.items;
      var parentIds = new Set();
      var surchargesByParent = {};
      var orphanKeys = [];

      // Collect valid session IDs from parent items; track discount price rules
      var currentDiscounts = {};
      var parentQuantities = {};
      items.forEach(function (item) {
        var p = item.properties || {};
        if (p._wgh_addon !== '1' && p._wgh_session) {
          parentIds.add(p._wgh_session);
          parentQuantities[p._wgh_session] = item.quantity;
          if (p._wgh_price_rule_id) currentDiscounts[p._wgh_session] = p._wgh_price_rule_id;
        }
      });

      // Delete price rules for sessions that were present last run but are now gone
      Object.keys(activeDiscounts).forEach(function (sid) {
        if (!currentDiscounts[sid]) deleteCartDiscount(activeDiscounts[sid]);
      });
      activeDiscounts = currentDiscounts;

      // Map surcharges by session ID; orphan = no matching session
      items.forEach(function (item) {
        var p = item.properties || {};
        if (p._wgh_addon !== '1') return;
        var sid = p._wgh_parent;
        if (!sid || !parentIds.has(sid)) { orphanKeys.push(item.key); return; }
        if (!surchargesByParent[sid]) surchargesByParent[sid] = [];
        surchargesByParent[sid].push({
          key:            item.key,
          price:          item.price,
          disc_price:     p._wgh_disc_price  != null ? parseInt(p._wgh_disc_price)  : null,
          name:           p._wgh_for         || null,
          opt_label:      p._wgh_opt_label   || null,
          variant_name:   p._wgh_variant     || null,
          line_price:     item.line_price,
          quantity:       item.quantity,
          price_per_char: p._wgh_price_per_char ? parseInt(p._wgh_price_per_char) : null,
          price_per_unit: p._wgh_price_per_unit ? parseInt(p._wgh_price_per_unit) : null
        });
      });

      if (orphanKeys.length) {
        removeCartItems(orphanKeys).then(function () { window.location.reload(); });
        return;
      }

      // Sync surcharge quantities to match parent item quantity
      var qtyUpdates = {};
      Object.keys(surchargesByParent).forEach(function (sid) {
        var parentQty = parentQuantities[sid];
        if (parentQty == null) return;
        surchargesByParent[sid].forEach(function (s) {
          if (s.key && s.quantity !== parentQty) qtyUpdates[s.key] = parentQty;
        });
      });
      if (Object.keys(qtyUpdates).length) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: qtyUpdates })
        }).then(function () { scheduleRun(); });
        return;
      }

      document.querySelectorAll('[id^="CartItem-"]').forEach(function (el) {
        var idx = parseInt(el.id.replace('CartItem-', ''), 10) - 1;

        // Out of range — show it, don't touch it
        if (isNaN(idx) || idx < 0 || idx >= items.length) {
          el.classList.add('wgh-ready');
          return;
        }

        var item = items[idx];
        var p = item.properties || {};

        if (p._wgh_addon === '1') {
          el.remove(); // out of DOM entirely — no remove button accessible
          return;
        }

        var surcharges = surchargesByParent[p._wgh_session || ''];

        if (surcharges && surcharges.length) {
          var byName = {};
          surcharges.forEach(function (s) { if (s.name) byName[s.name] = s; });
          addPricesToProps(el, byName);
          injectUpsellProps(el, surcharges);

          var surchargeTotal = surcharges.reduce(function (sum, s) {
            return sum + (s.disc_price != null ? s.disc_price * (s.quantity || 1) : s.line_price);
          }, 0);
          showCombinedPrice(el, item.line_price, item.line_price + surchargeTotal);
        }

        // Vervang productafbeelding door personalizer-preview indien aanwezig
        if (p._pz_preview_url) {
          injectPreviewImage(el, p._pz_preview_url);
        }

        // Reveal the row (with or without surcharges)
        el.classList.add('wgh-ready');
      });
    }).catch(function (err) {
      console.warn('[WGH cart]', err);
      showAll();
    });
  }

  function addPricesToProps(cartItemEl, byName) {
    cartItemEl.querySelectorAll('.product-option').forEach(function (el) {
      if (el.querySelector('.wgh-cart-prop__price')) return;
      var dt = el.querySelector('dt');
      var dd = el.querySelector('dd');
      if (!dt || !dd) return;

      var name = dt.textContent.replace(/:$/, '').trim();
      var s = byName[name];
      if (!s) return;
      var price  = s.price || 0;
      var suffix = s.price_per_char ? ' (per letter)' : s.price_per_unit ? ' (per eenheid)' : '';

      var span = document.createElement('span');
      span.className = 'wgh-cart-prop__price';
      span.textContent = '+' + fmt(price) + suffix;
      dd.appendChild(span);
    });
  }

  function showCombinedPrice(cartItemEl, baseLineCents, combinedLineCents) {
    if (baseLineCents === combinedLineCents) return;

    // Two wrappers per row: mobile column + desktop column
    cartItemEl.querySelectorAll('.cart-item__price-wrapper').forEach(function (wrapper) {
      if (wrapper.querySelector('.wgh-cart-price-combined')) return;

      var priceEl = wrapper.querySelector('.price--end') || wrapper.querySelector('.price');
      if (!priceEl) return;

      var container = document.createElement('div');
      container.className = 'wgh-cart-price-combined';

      var totalEl = document.createElement('span');
      totalEl.className = 'price price--end wgh-cart-price-combined__total';
      totalEl.textContent = fmt(combinedLineCents);

      container.appendChild(totalEl);

      priceEl.parentNode.replaceChild(container, priceEl);
    });
  }

  function injectUpsellProps(cartItemEl, surcharges) {
    var dl = cartItemEl.querySelector('.cart-item__details dl');
    if (!dl) return;

    function safe(str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    surcharges.forEach(function (s) {
      if (!s.name) return;
      var label = s.opt_label || s.name;

      // Prevent double-injection
      if (Array.prototype.some.call(dl.querySelectorAll('[data-wgh-upsell]'), function (el) {
        return el.getAttribute('data-wgh-upsell') === label;
      })) return;

      // Skip if this label already exists as a native property row
      if (Array.prototype.some.call(dl.querySelectorAll('.product-option:not([data-wgh-upsell]) dt'), function (dt) {
        return dt.textContent.replace(/:$/, '').trim() === label;
      })) return;

      var unitPrice = s.disc_price != null ? s.disc_price : Math.round((s.line_price || 0) / (s.quantity || 1));
      var rowLabel  = safe(s.name) + (s.variant_name ? ' - ' + safe(s.variant_name) : '');
      var qty       = s.quantity || 1;

      var group = document.createElement('div');
      group.setAttribute('data-wgh-upsell', label);
      group.style.cssText = 'display:block;width:100%;margin-top:12px';

      var header = document.createElement('div');
      header.style.cssText = 'display:block;font-size:.82em;color:#888;margin-bottom:2px';
      header.textContent = 'In combinatie met:';
      group.appendChild(header);

      for (var i = 0; i < qty; i++) {
        var row = document.createElement('div');
        row.style.cssText = 'display:flex;justify-content:space-between;align-items:baseline;gap:8px;padding:1px 0';

        var labelSpan = document.createElement('span');
        labelSpan.style.cssText = 'flex:1;min-width:0';
        labelSpan.innerHTML = rowLabel;

        var priceSpan = document.createElement('span');
        priceSpan.className = 'wgh-cart-prop__price';
        priceSpan.style.cssText = 'flex-shrink:0;white-space:nowrap';
        priceSpan.textContent = '+' + fmt(unitPrice);

        row.appendChild(labelSpan);
        row.appendChild(priceSpan);
        group.appendChild(row);
      }

      dl.appendChild(group);
    });
  }

  function injectPreviewImage(cartItemEl, url) {
    if (cartItemEl.querySelector('.wgh-preview-img')) return;
    var mediaEl = cartItemEl.querySelector('.cart-item__media');
    if (!mediaEl) return;
    var img = mediaEl.querySelector('img');
    if (!img) return;

    img.src = url;
    img.srcset = '';
    img.sizes = '';
    img.classList.add('wgh-preview-img');

    var trigger = mediaEl.querySelector('a') || img;
    if (trigger.tagName === 'A') {
      trigger.removeAttribute('href');
      trigger.style.cursor = 'zoom-in';
    } else {
      img.style.cursor = 'zoom-in';
    }
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openPreviewModal(url);
    });
  }

  function openPreviewModal(url) {
    if (document.getElementById('wgh-preview-modal')) return;
    var overlay = document.createElement('div');
    overlay.id = 'wgh-preview-modal';
    overlay.style.cssText = [
      'position:fixed', 'inset:0', 'z-index:9999',
      'background:rgba(0,0,0,.82)', 'display:flex',
      'align-items:center', 'justify-content:center',
      'cursor:zoom-out', 'padding:24px', 'box-sizing:border-box'
    ].join(';');

    var img = document.createElement('img');
    img.src = url;
    img.style.cssText = [
      'max-width:100%', 'max-height:100%', 'object-fit:contain',
      'border-radius:6px', 'box-shadow:0 8px 40px rgba(0,0,0,.6)',
      'pointer-events:none'
    ].join(';');
    overlay.appendChild(img);
    document.body.appendChild(overlay);

    function close() {
      overlay.remove();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
  }

  var runTimer;
  function scheduleRun() {
    clearTimeout(runTimer);
    runTimer = setTimeout(run, 200);
  }

  var _fetch = window.fetch;
  window.fetch = function (url) {
    var res = _fetch.apply(this, arguments);
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    if (u.includes('/cart/change') || u.includes('/cart/update')) {
      res.then(scheduleRun, function () {});
    } else if (u.includes('/cart/add')) {
      res.then(scheduleRun, function () {});
    }
    return res;
  };

  document.addEventListener('cart:refresh', scheduleRun);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();